export default __webpack_public_path__ + "static/media/ve_0.541e5543.mp3";